import type { SVGProps } from "react"

type StarsProps = {
  rating: number
}

export const Stars = ({ rating }: StarsProps) => {
  return (
    <div className="flex items-center gap-[4px]">
      {[0, 1, 2, 3, 4].map((i) => {
        const diff = rating - i
        if (diff >= 1) {
          return <FilledStarIcon key={i} />
        } else if (diff > 0.5) {
          return <AboveHalfFilledStarIcon key={i} />
        } else if (diff > 0) {
          return <BelowHalfAndHalfFilledStarIcon key={i} />
        } else {
          return <EmptyStarIcon key={i} />
        }
      })}
    </div>
  )
}

export const ProductRating = ({ rating, count_responses }: { rating: number; count_responses: number }) => {
  return (
    <div className="mt-1 flex items-center gap-1">
      <Stars rating={rating} />
      <p className="font-nunito">({count_responses})</p>
    </div>
  )
}

// StarIcon now takes fillPercent: number (0 to 1) and index for unique gradient
const FilledStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" {...props} viewBox="0 0 220 220">
    <path
      fill="#067BF2"
      stroke="#067BF2"
      strokeWidth={10}
      d="M97.132 14.704c4.208-12.939 22.528-12.939 26.735 0l15.034 46.231a14.053 14.053 0 0 0 13.367 9.705h48.649c13.616 0 19.278 17.41 8.263 25.406l-39.359 28.573a14.038 14.038 0 0 0-5.106 15.702l15.033 46.231c4.208 12.939-10.613 23.699-21.629 15.702l-39.358-28.572a14.062 14.062 0 0 0-16.523 0L62.88 202.254c-11.015 7.997-25.836-2.763-21.629-15.702l15.034-46.231a14.038 14.038 0 0 0-5.106-15.702L11.82 96.046C.805 88.05 6.467 70.64 20.082 70.64h48.65c6.089 0 11.485-3.918 13.367-9.705l15.033-46.23Z"
    />
  </svg>
)

const AboveHalfFilledStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" {...props} viewBox="0 0 220 220">
    <path
      fill="#067BF2"
      d="M164.5 126 146 72.5l-28-67h-14l-9.5 17-18.5 46H38l-30 4V91l35.5 27.5L60 134l-20 47v19l20 6.5 52-36.5 40 30 20.5 6.5 9-17.5-17-63Z"
    />
    <path
      stroke="#067BF2"
      strokeWidth={10}
      d="M97.132 14.704c4.208-12.939 22.528-12.939 26.735 0l15.034 46.231a14.053 14.053 0 0 0 13.367 9.705h48.649c13.616 0 19.278 17.41 8.262 25.406l-39.358 28.573a14.038 14.038 0 0 0-5.106 15.702l15.033 46.231c4.208 12.939-10.613 23.699-21.629 15.702l-39.358-28.572a14.062 14.062 0 0 0-16.523 0L62.88 202.254c-11.015 7.997-25.836-2.763-21.629-15.702l15.034-46.231a14.038 14.038 0 0 0-5.106-15.702L11.82 96.046C.805 88.05 6.467 70.64 20.082 70.64h48.65c6.089 0 11.485-3.918 13.367-9.705l15.033-46.23Z"
    />
  </svg>
)

const BelowHalfAndHalfFilledStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" {...props} viewBox="0 0 220 220">
    <path fill="#067BF2" d="M111 171.5V6.5h-10l-7 14L80.5 69 26 70.5 9 77 6 93.5 29.5 104 46 117l12 16.5-12 43-3.5 25.5 17 5.5 51.5-36Z" />
    <path
      stroke="#067BF2"
      strokeWidth={10}
      d="M97.132 14.704c4.208-12.939 22.528-12.939 26.735 0l15.034 46.231a14.053 14.053 0 0 0 13.367 9.705h48.649c13.616 0 19.278 17.41 8.262 25.406l-39.358 28.573a14.038 14.038 0 0 0-5.106 15.702l15.033 46.231c4.208 12.939-10.613 23.699-21.629 15.702l-39.358-28.572a14.062 14.062 0 0 0-16.523 0L62.88 202.254c-11.015 7.997-25.836-2.763-21.629-15.702l15.034-46.231a14.038 14.038 0 0 0-5.106-15.702L11.82 96.046C.805 88.05 6.467 70.64 20.082 70.64h48.65c6.089 0 11.485-3.918 13.367-9.705l15.033-46.23Z"
    />
  </svg>
)

const EmptyStarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" {...props} viewBox="0 0 220 220">
    <path
      stroke="#067BF2"
      strokeWidth={10}
      d="M97.132 14.704c4.208-12.939 22.528-12.939 26.735 0l15.034 46.231a14.053 14.053 0 0 0 13.367 9.705h48.649c13.616 0 19.278 17.41 8.262 25.406l-39.358 28.573a14.038 14.038 0 0 0-5.106 15.702l15.033 46.231c4.208 12.939-10.613 23.699-21.629 15.702l-39.358-28.572a14.062 14.062 0 0 0-16.523 0L62.88 202.254c-11.015 7.997-25.836-2.763-21.629-15.702l15.034-46.231a14.038 14.038 0 0 0-5.106-15.702L11.82 96.046C.805 88.05 6.467 70.64 20.082 70.64h48.65c6.089 0 11.485-3.918 13.367-9.705l15.033-46.23Z"
    />
  </svg>
)
